import { motion } from "framer-motion";
import { ProjectLink } from "../data/projects";
import { itemUp } from "../Utils/framerMotionVariants";

const ProjectLinkTag: React.FC<{ projectLink: ProjectLink }> = ({
  projectLink,
}) => {
  return (
    <motion.a
      variants={itemUp}
      key={projectLink.tag}
      href={projectLink.link}
      className="text-sm px-3 py-2 rounded-md border border-white/20 hover:border-cyan-400 hover:shadow-lg transition"
      target="_blank"
      rel="noreferrer"
    >
      <i className={`${projectLink.icon} mr-1`}></i>
      {projectLink.tag}
    </motion.a>
  );
};

export default ProjectLinkTag;
